export const COMMON_REVIEWS_UI_FLAG = 'COMMON_REVIEWS';
export const EMPTY_OBJ = {};
